import { render } from "./OrderMoney.vue?vue&type=template&id=f3c1d3b4&scoped=true"
import script from "./OrderMoney.vue?vue&type=script&lang=js"
export * from "./OrderMoney.vue?vue&type=script&lang=js"

import "./OrderMoney.vue?vue&type=style&index=0&id=f3c1d3b4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c1d3b4"]])

export default __exports__